import BgService from './BgService';
import { pexels } from './providers';
import { refresh, innerTextById, bySelector, byElement } from './binder'

const d = {
    author: 'Snapwire provided by Pexels',
    link: 'https://images.pexels.com/photos/292442/pexels-photo-292442.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    next,
    title: '',
    url: '/img/bg.jpg'
},
m = {
    author: innerTextById('author'),
    link: bySelector('#link', (el, v) => el.href = v),
    next: bySelector('#next', (el, v) => el.onclick = v),
    title: innerTextById('title'),
    url: byElement(document.body, (el, v) => el.style.backgroundImage = `url(${v})`)
},
bgService = new BgService(new pexels());

// init
refresh(d, m);

// click handler for the play button
function next() {
    bgService
        .next()
        .then(p => {
            const preload = new Image();
            preload.src = p.url;
            preload.onload = _ => refresh(p, m);
        });
}
